import { LoadingState } from "~/components/screens/StateScreen"

import { useParams } from "react-router-dom"
import { Editor } from "~/components/editor/Editor"
import { api } from "~/trpc/react"

export default function SharePage() {
	const { shareId = "" } = useParams<{ shareId: string }>()
	const share = api.knowledgeBase.publicShare.useQuery({ shareId })

	if (share.isLoading) {
		return <LoadingState scope="page" />
	}

	if (!share.data) {
		return (
			<main className="flex min-h-screen items-center justify-center bg-background-secondary px-6">
				<div className="max-w-md rounded-xl border border-stroke bg-background p-6 text-center shadow-lg">
					<h1 className="text-xl font-semibold text-text-main">
						Share link unavailable
					</h1>
					<p className="mt-2 text-sm text-text-sub">
						This document link is expired, removed, or does not exist.
					</p>
				</div>
			</main>
		)
	}

	return (
		<main className="min-h-screen bg-background-secondary px-5 py-8">
			<article className="mx-auto max-w-3xl rounded-xl border border-stroke bg-background p-6 shadow-lg sm:p-8">
				<div className="mb-6 border-b border-stroke pb-5">
					<p className="text-xs font-medium uppercase tracking-wide text-text-small">
						{share.data.document.organization.name} /{" "}
						{share.data.document.team.name}
					</p>
					<h1 className="mt-2 text-3xl font-semibold text-text-main">
						{share.data.document.title}
					</h1>
					{share.data.document.description ? (
						<p className="mt-2 text-text-sub">
							{share.data.document.description}
						</p>
					) : null}
				</div>
				<Editor
					variant="document"
					initialState={share.data.document.content ?? null}
					disabled
				/>
			</article>
		</main>
	)
}
